import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import {
  loadCaptchaEnginge,
  LoadCanvasTemplate,
  validateCaptcha,
} from "react-simple-captcha";
import {
  InputGroup,
  Button,
  Form,
  FormGroup,
  FormInput,
  InputGroupAddon,
  FormFeedback,
  InputGroupText,
} from "shards-react";
import { useTranslation } from "react-i18next";
import { storeAuthToken, storeOpenMenu } from "shared/utils/authToken";
// import { storeCurrentUser } from "shared/utils/currentUser";

import baseUrl from "config/baseUrl";

const axios = require("axios").default;

const Link = styled.a`
  color: ${(props) => props.color || "#000"};
  display: block;
  cursor: pointer;
  :hover {
    color: ${(props) => props.color || "#000"};
    text-decoration: none;
  }
`;

const StyledLoadCanvasTemplate = styled.div`
  #canv {
    border: 1px solid #dee2e6;
    border-radius: 4px;
    height: 38px;
    padding-top: 5px;
  }
`;
const FormLogin = (props) => {
  const { onChangeStatus } = props;
  const { t, i18n } = useTranslation();
  const [userNmae, setUserNmae] = useState("");
  const [password, setPassword] = useState("");
  const [showPass, setShowPass] = useState("password");
  const [error, setError] = useState(false);
  const [messageError, setMessageError] = useState("");
  const [captcha, setCaptcha] = useState("");
  const [captchamessageError, setCaptchaMessageError] = useState(null);

  useEffect(() => {
    loadCaptchaEnginge(6);
  }, {});
  const showPassword = () => {
    setShowPass(showPass === "password" ? "text" : "password");
  };
  const doSubmit = () => {
    if (validateCaptcha(captcha) === true) {
      loadCaptchaEnginge(6);
      setCaptcha("");
      setCaptchaMessageError(null);
    } else {
      setCaptchaMessageError("กรุณาลองอีกครั้ง");
      setCaptcha("");
    }
  };
  const onLogin = (e) => {
    e.preventDefault();
    if (validateCaptcha(captcha) === true) {
      axios
        .post(`${baseUrl}/v1/auth/login`, {
          username: userNmae,
          password: password,
        })
        .then((response) => {
          storeAuthToken(response.data.token);
          // storeCurrentUser(response.data.user);
          storeOpenMenu(true);
          onChangeStatus(5);
        })
        .catch((error) => {
          setError(true);
          loadCaptchaEnginge(6);
          setCaptcha("");
          setCaptchaMessageError(null);
          setMessageError(
            "ชื่อผู้ใช้งานหรือรหัสผ่านไม่ถูกต้อง กรุณาตรวจสอบใหม่อีกครั้ง"
          );
        });
    } else {
      setCaptchaMessageError("กรุณาลองอีกครั้ง");
      setCaptcha("");
    }
  };
  return (
    <>
      <h6 className="bold text-center">{t("common:logIn.Login")}</h6>
      <Form  onSubmit={onLogin}>
        <FormGroup>
          <label htmlFor="#username">{t("common:logIn.Username")}</label>
          <FormInput
            type="text"
            placeholder={t("common:logIn.Username")}
            value={userNmae}
            onChange={(e) => {
              setUserNmae(e.target.value);
              setError(false);
            }}
            invalid={error}
          />
        </FormGroup>
        <FormGroup>
          <label htmlFor="#password">{t("common:logIn.Password")}</label>
          <InputGroup seamless>
            <FormInput
              type={showPass}
              placeholder={t("common:logIn.Password")}
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                setError(false);
              }}
              invalid={error}
            />
            {password && (
              <InputGroupAddon type="append">
                <InputGroupText>
                  <Link color={"#5A5A5A"} onClick={showPassword}>
                    {showPass === "password" ? (
                      <FontAwesomeIcon icon={faEye} />
                    ) : (
                      <FontAwesomeIcon icon={faEyeSlash} />
                    )}
                  </Link>
                </InputGroupText>
              </InputGroupAddon>
            )}
          </InputGroup>
          {error && (
            <FormFeedback>{t("common:logIn.PleaseCheckAgain")}</FormFeedback>
          )}
        </FormGroup>
        <StyledLoadCanvasTemplate>
          <LoadCanvasTemplate reloadText={t("common:logIn.Change")} />
        </StyledLoadCanvasTemplate>
        <FormGroup>
          <FormInput
            type="text"
            placeholder=""
            value={captcha}
            onChange={(e) => {
              setCaptcha(e.target.value);
            }}
          />
          {captchamessageError && (
            <FormFeedback>{t("common:logIn.pleaseTryAgain")}</FormFeedback>
          )}
        </FormGroup>
        <Link className="mb-5" onClick={() => onChangeStatus(3)}>
          {t("common:logIn.ForgotPassword")}
        </Link>
        <Button
          className="btn btn-success w-100 mb-3"
          onClick={onLogin}
          type="submit"
          disabled={!userNmae || !password}
        >
          {t("common:logIn.Login")}
        </Button>
        <Link className="w-100 text-center" onClick={() => onChangeStatus(2)}>
          {t("common:logIn.Register")}
        </Link>
      </Form>
    </>
  );
};

export default FormLogin;
